"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var DoctorHero = function () {
    return ((0, preact_1.h)("div", { className: "doctor-hero" },
        (0, preact_1.h)("div", { className: "doctor-hero__container" },
            (0, preact_1.h)("p", { className: "doctor-hero__eyebrow" }, "MEET OUR"),
            (0, preact_1.h)("p", { className: "doctor-hero__header" }, "Medical Advisory Board"),
            (0, preact_1.h)("p", { className: "doctor-hero__subheader" },
                "We work with a diverse team of ",
                (0, preact_1.h)("br", { className: "hide-on-desktop" }),
                "esteemed doctors who specialize in ",
                (0, preact_1.h)("br", { className: "hide-on-desktop" }),
                "women\u2019s ",
                (0, preact_1.h)("br", { className: "hide-on-mobile" }),
                "health & hormones. Together, ",
                (0, preact_1.h)("br", { className: "hide-on-desktop" }),
                "we create products with high-quality ",
                (0, preact_1.h)("br", { className: "hide-on-desktop" }),
                "ingredients that ",
                (0, preact_1.h)("br", { className: "hide-on-mobile" }),
                "effectively address the root ",
                (0, preact_1.h)("br", { className: "hide-on-desktop" }),
                "cause\u2014to help you feel better longterm."))));
};
exports.default = DoctorHero;
